import { ButtonProps, IconProps } from 'semantic-ui-react'
import { CalendarSpec } from 'moment'

export const SEARCH_DELAY = 200
export const TROVE_FILTER_TYPES = ['Active', 'Starred', 'Attention']
export const TROVE_FILTER_COLORS: ButtonProps['color'][] = ['blue', 'violet', 'red']
export const TROVE_FILTER_ICONS: IconProps['name'][] = ['bookmark', 'star', 'flag']
// export const TROVE_FILTER_ICONS: IconProps['name'][] = ['idea', 'star', 'flag']
// export const TROVE_FILTER_ICONS: IconProps['name'][] = ['star half', 'star', 'flag']
// export const TROVE_FILTER_TYPES = ['Active', 'Week', 'Day', 'Priority']
// export const TROVE_FILTER_COLORS: ButtonProps['color'][] = ['olive', 'yellow', 'orange', 'red']
// export const TROVE_FILTER_TYPES = ['Active', 'Week', 'Priority']
// export const TROVE_FILTER_COLORS: ButtonProps['color'][] = ['blue', 'yellow', 'red']

export const GA_ID = 'UA-169250641-1'

export const defaultWorkspaceData = '{"tree":{"key":"root","parent":null,"sub":[{"key":"YnKFTQJZLfrj","parent":"root","createdAt":1587607821927,"sub":[{"key":"JVrsDStMaVlc","parent":"YnKFTQJZLfrj","createdAt":1587607836373}]},{"key":"VPbmdwggGHJv","parent":"root","createdAt":1587607791427},{"key":"RgylOEGtcSQQ","parent":"root","createdAt":1587607812205,"sub":[{"key":"hdNpMnuKSgZo","parent":"RgylOEGtcSQQ","createdAt":1587607780921,"funnel":1,"sub":[{"key":"EEJHdAJsqGFA","parent":"hdNpMnuKSgZo","createdAt":1589584509947}],"folded":true}]},{"key":"HoLZRBcHfdcB","parent":"root","createdAt":1587607829384},{"key":"CmfBXyJPMqjt","createdAt":1591396943480,"updatedAt":1591396943480,"sub":[{"key":"IWqpMGFRViiV","createdAt":1591396968540,"updatedAt":1591396968540},{"key":"UNOvwseAMeXb","createdAt":1591396972020,"updatedAt":1591396972020},{"key":"WFQZdKgBvXpN","createdAt":1591396973954,"updatedAt":1591396973954}],"folded":true}]},"items":{"hdNpMnuKSgZo":{"key":"hdNpMnuKSgZo","text":"📕 Reading List","updatedAt":1587607815302,"troved":true},"VPbmdwggGHJv":{"key":"VPbmdwggGHJv","text":"🕺 People","updatedAt":1587607808427},"RgylOEGtcSQQ":{"key":"RgylOEGtcSQQ","text":"🏖 Leasure","updatedAt":1587607813062},"YnKFTQJZLfrj":{"key":"YnKFTQJZLfrj","text":"💁‍♂️ Personal","updatedAt":1587607825173,"troved":true},"HoLZRBcHfdcB":{"key":"HoLZRBcHfdcB","text":"🏛 Companies","updatedAt":1587607834329},"JVrsDStMaVlc":{"key":"JVrsDStMaVlc","text":"💰 Taxes Checklist","updatedAt":1587607847005},"EEJHdAJsqGFA":{"key":"EEJHdAJsqGFA","text":"Three tips for navigating your foggy brain: https://medium.com/@onnofaber/three-tips-for-navigating-your-foggy-brain-b98d3e9a691f","updatedAt":1589584520643},"CmfBXyJPMqjt":{"key":"CmfBXyJPMqjt","text":"🏆 HolyGrail Feedback","createdAt":1591396954489,"updatedAt":1591396962847},"IWqpMGFRViiV":{"key":"IWqpMGFRViiV","text":"Ideas","createdAt":1591396971412,"updatedAt":1591396971420},"UNOvwseAMeXb":{"key":"UNOvwseAMeXb","text":"Bugs","createdAt":1591396973346,"updatedAt":1591396973351},"WFQZdKgBvXpN":{"key":"WFQZdKgBvXpN","text":"Thoughts","createdAt":1591396978083,"updatedAt":1591396978087}},"plans":{},"appVersion":"0.1.48"}'

export const changelog: {
  [key: string]: string[]
} = {
  '0.1.51': [
    'Add date navigator in checklist sidebar',
    'Allow dropping minddump files from mobile app (HolyGrail Minddump) to import them'
  ],
  '0.1.50': [
    'Added a chat button for in-app support',
    'Fixed issues in calendar view'
  ],
  '0.1.49': [
    'Improvements in weekview design and functionality',
    'Various bugfixes and design improvements',
    'Secrets...',
  ],
  '0.1.48': [
    'Show unscheduled checklists in weekview',
    'Ability to name a checklist on creation',
    'Design improvements',
  ],
  '0.1.47': [
    'Improved weekview navigation, navigate through time and better use of real estate',
  ],
  '0.1.46': [
    'New experimental weekview planning feature',
    'Small design tweaks',
  ],
  '0.1.45': [
    'New recent items menu, to quickly jump to the last items',
    'You can now drag items directly on the left trove menu'
  ],
  '0.1.44': [
    'Various design improvements',
    'Date range select in experimental checklist feature',
    'Drag and drop improvements',
  ],
  '0.1.43': [
    'Updates on experimental checklist feature, improved design, drag and drop from trove, edit items in place',
    'Various design updates',
  ],
  '0.1.42': [
    'See what\'s new',
    'Bugfix in desktop app',
  ],
  '0.1.40': [
    'Ability to check new versions manually (desktop)',
    'Minor bugfixes',
  ],
  '0.1.39': [
    'Improved experimental checklist feature',
    'Bugfixes',
  ],
  '0.1.38': [
    'Bugfixes',
  ],
  '0.1.37': [
    'Speed improvements',
    'Bugfixes',
  ],
  '0.1.36': [
    'Emoji picker',
    'Bugfixes',
    'Better shortcut menus',
  ],
}

export const momentCalendarFormatDate: CalendarSpec = {
  sameDay: '[Today]',
  nextDay: '[Tomorrow]',
  nextWeek: 'dddd',
  lastDay: '[Yesterday]',
  lastWeek: '[Last] dddd',
  sameElse: 'L'
}

export const momentCalendarFormatDate2: CalendarSpec = {
  sameDay: '[Today]',
  nextDay: 'dddd',
  nextWeek: 'dddd',
  lastDay: 'dddd',
  lastWeek: 'dddd',
  sameElse: 'dddd'
}
